import React from "react";
import { Route, Redirect } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import Header from "components/Header/Header.jsx";
import AccessDenied from "components/ErrorPage/AccessDenied.jsx";
import { cryptoTokenDecode } from "components/Common/Common";

/**
 * @desc HOC for creating private route and set access based on roles
 */

export const PrivateRoute = ({
  miniActive: miniActive,
  onUpdate,
  permissionType,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      var usertype1 = cryptoTokenDecode().usertype;

      if (
        usertype1 !== undefined &&
        usertype1 !== null &&
        localStorage.getItem("accessToken") !== undefined &&
        localStorage.getItem("accessToken") !== "" &&
        localStorage.getItem("accessToken") != null
      ) {
        let usertype = usertype1;
        let permissionTypes = cryptoTokenDecode().permissionTypes;

        if (cryptoTokenDecode().organization !== "dotwork") {
          if (localStorage.getItem("usertype") != "ADMIN") {
            let firstOpen = localStorage.getItem("firstOpen");
            localStorage.clear();
            const currentDate = new Date();
            localStorage.setItem("lastOpenedDate", currentDate.toDateString());
            localStorage.setItem("firstOpen", firstOpen);
          } else {
            localStorage.clear();
          }

          return <Redirect to={{ pathname: "/login" }} />;
        }

        // console.log("permissionTypes user given", permissionTypes);
        // console.log("permission type route", permissionType);

        let found = 0;

        for (let i = 0; i < permissionType.length; i++) {
          for (let j = 0; j < permissionTypes.length; j++) {
            // console.log('permissionType[i]: ', permissionType[i]);
            // console.log('permissionTypes[j]: ', permissionTypes[j]);
            if (permissionType[i] === permissionTypes[j]) {
              found = 1;
              break;
            }
          }
          if (found === 1) {
            break;
          }
        }

        // console.log('permissionTYPE: ', permissionType);
        // console.log('permissionTYPES: ', permissionTypes);
        // console.log('usertype: ', usertype);
        // console.log('found: ', found);

        if (found === 0) {
          //    if (permissionType && permissionType.indexOf(usertype) === -1) {
          // role not authorised so redirect to home page
          return (
            <React.Fragment>
              <Sidebar miniActive={miniActive} rerander={Math.random()} />
              <div className={miniActive + " contentArea"}>
                <Header
                  miniActive={miniActive}
                  onUpdate={onUpdate}
                  {...props}
                />
                <AccessDenied {...props} />
              </div>
            </React.Fragment>
          );
        }

        return (
          <React.Fragment>
            <Sidebar miniActive={miniActive} rerander={Math.random()} />
            <div className={miniActive + " contentArea"}>
              <Header miniActive={miniActive} onUpdate={onUpdate} {...props} />
              <Component {...props} />
            </div>
          </React.Fragment>
        );
      } else {
        return <Redirect to={{ pathname: "/login" }} />;
      }
    }}
  />
);
